/**
 * Announcement Bar — Auto-rotating messages
 */
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.announcement-bar__item');
    this.current = 0;
    this.timer = null;
  }

  connectedCallback() {
    if (this.items.length <= 1) return;
    const speed = parseInt(this.dataset.speed) || 4;
    this.timer = setInterval(() => this.next(), speed * 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  next() {
    this.items[this.current].classList.remove('active');
    this.current = (this.current + 1) % this.items.length;
    this.items[this.current].classList.add('active');
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
